import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import '../node_modules/react-image-gallery/styles/css/image-gallery.css';
import { queryClient } from './lib/react-query';
import App from './App';
import './components/Button/style.css';
import './components/ConfirmBox/style.css';
import { Spinner } from './components/Spinner/Spinner';
import './components/Upload/style.css';
import './i18n';
import './index.css';
import { AuthLoader } from './lib/auth';
import reportWebVitals from './reportWebVitals';
import registerServiceWorker from './services/registerServiceWorker';
import './styles/main.css';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import * as Sentry from '@sentry/react';
import NotFound from './screens/Auth/NotFound';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
  integrations: [
    Sentry.browserTracingIntegration({
      traceFetch: false, // Disable auto-tracing of requests
      traceXHR: false,
    }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/fishvoy\.com\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// save records in cache until they are stale (Infinity)

root.render(
  <>
    <Sentry.ErrorBoundary fallback={<NotFound withHeader={true}/>}>
    <React.StrictMode>
      <Suspense fallback={<Spinner className="loader-absolute" />}>
        <QueryClientProvider client={queryClient}>
          {process.env.REACT_APP_ENVIRONMENT === 'development' && (
            <ReactQueryDevtools position="bottom-right" initialIsOpen={false} />
          )}
          <AuthLoader renderLoading={() => <Spinner className="loader-absolute" />}>
            <Router>
              <Routes>
                <Route path="/*" element={<App />} />
              </Routes>
            </Router>
          </AuthLoader>
        </QueryClientProvider>
      </Suspense>
    </React.StrictMode>
    <NotificationContainer />
    </Sentry.ErrorBoundary>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
